import { all, call, fork, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { appConfig } from "../config"
import keycloak from "../keycloak"

import {
  fetchCurrentInventorySuccess,
  fetchInventoryItemSuccess,
  fetchInventoryItemCartonsSuccess,
  fetchInventoryItemError,
  updateInspectionLocationSuccess,
  createInventoryProductSuccess,
  createInventoryProductError,
} from "../actions/Inventory";

import {
  FETCH_CURRENT_INVENTORY,
  FETCH_INVENTORY_ITEM,
  FETCH_INVENTORY_ITEM_CARTONS,
  FETCH_INVENTORY_ITEM_BY_CARTON_ID,
  UPDATE_INSPECTION_LOCATION,
  UPDATE_INSPECTION_LOCATION_SUCCESS,
  CREATE_PRODUCT,
} from "../constants/ActionTypes";

const baseUrl = appConfig.baseApiUrl

const withHeaders = async (block) => {
  return await keycloak.updateToken(20).then(() => (
    block({
      'Authorization': 'Bearer ' + keycloak.token,
      'Csrf-Token': 'nocheck-allow',
      'Content-Type': 'application/json'
      })
  ));
}

const getCurrentInventory = async (data) => {
  const params = data.payload;
  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/inventory/current", { headers: headers, params: params })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const getInventoryItem = async (data) => {
  const itemId = data.payload;

  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/inventory/item", { headers: headers, params: { itemId } })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
}

const getInventoryItemCartons = async (data) => {
  const itemId = data.payload;

  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/inventory/itemCartons", { headers: headers, params: { itemId } })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const getInventoryItemByCartonId = async (data) => {
  const cartonId = data.payload;

  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/inventory/itemByCartonId", { headers: headers, params: { cartonId } })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}
const getWarehouseEventsByCartonId = async (data) => {
  const cartonId = data.payload;

  return await withHeaders((headers) => {
    return axios.get(baseUrl + "/api/inventory/warehouseEvents", { headers: headers, params: { cartonId } })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const updateInspectionLocation = async (data) => {
  const { id, warehouseLocation } = data.payload;

  return await withHeaders((headers) => {
    return axios.post(baseUrl + `/api/inspections/itemCartons/${id}/location`, null, { headers:  headers, params: { warehouseLocation } })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  })
}

const createProduct = async (data) => {
  const productSubmission = data.payload;
  console.log('payload: productSubmission: ', productSubmission);

  return await withHeaders((headers) => {
    return axios.post(baseUrl + `/api/catalog/productsFromFeed`, productSubmission, { headers: headers })
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Bad response from server");
        }
        return response.data;
      });
  });
}


function* fetchCurrentInventoryRequest(data) {
  try {
    const fetched = yield call(getCurrentInventory, data);
    yield put(fetchCurrentInventorySuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* fetchInventoryItem(data) {
  try {
    const fetched = yield call(getInventoryItem, data);
    yield put(fetchInventoryItemSuccess(fetched));
  } catch (error) {
    console.error(error);
  }
}

function* fetchInventoryItemCartonsRequest(data) {
  try {
    const cartons = yield call(getInventoryItemCartons, data);
    const warehouseEvents = {};
    
    // fetch warehouse events for cartons
    if (cartons.length > 0) {
      for(let i=0; i < cartons.length; i++) {
        const cartonId = cartons[i].id.value;
        warehouseEvents[cartonId] = yield call(getWarehouseEventsByCartonId, { payload: cartonId });
      }
    }

    yield put(fetchInventoryItemCartonsSuccess({ cartons, warehouseEvents }));
  } catch (error) {
    yield put(fetchInventoryItemError(error));
    console.error(error);
  }
}

function* fetchInventoryItemByCartonIdRequest(data) {
  try {
    const fetched = yield call(getInventoryItemByCartonId, data);
    yield put(fetchInventoryItemSuccess(fetched));
  } catch (error) {
    yield put(fetchInventoryItemError(error));
    console.error(error);
  }
}

// refresh item / carton info on updates
function* updateInventoryItemByLocationUpdateSuccess(data) {
  try {
    const { payload: { id: { value: cartonId = null } } } = data || {};
    if (cartonId) {
        const fetched = yield call(getInventoryItemByCartonId, { payload: cartonId });
        yield put(fetchInventoryItemSuccess(fetched));
    }
  } catch (error) {
    yield put(fetchInventoryItemError(error));
    console.error(error);
  }
}

function* updateInspectionLocationRequest(data) {
  try {
    const updatedEntity = yield call(updateInspectionLocation, data);
    yield put(updateInspectionLocationSuccess(updatedEntity));
  } catch (error) {
    console.error("updateInspectionLocationRequest Error:", error);
  }
}

function* createProductRequest(data) {
  try {
    const createdProduct = yield call(createProduct, data);
    yield put(createInventoryProductSuccess(createdProduct));
  } catch (error) {
    yield put(createInventoryProductError(error));
    console.error('createProductRequest Error:', error);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(FETCH_CURRENT_INVENTORY, fetchCurrentInventoryRequest),
    takeLatest(FETCH_INVENTORY_ITEM, fetchInventoryItem),
    takeLatest(FETCH_INVENTORY_ITEM_CARTONS, fetchInventoryItemCartonsRequest),
    takeLatest(FETCH_INVENTORY_ITEM_BY_CARTON_ID, fetchInventoryItemByCartonIdRequest),
    takeEvery(UPDATE_INSPECTION_LOCATION, updateInspectionLocationRequest),
    takeEvery(UPDATE_INSPECTION_LOCATION_SUCCESS, updateInventoryItemByLocationUpdateSuccess),
    takeEvery(CREATE_PRODUCT, createProductRequest),
  ]);
}
